module.exports = __webpack_public_path__ + "img/LC2.de46f707.svg";